import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT, LOGO_WHITE } from "@/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy noise-overlay pt-20 pb-28 md:pb-16">
    <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-10 border-b border-ice/15 pb-14">
        <div className="md:col-span-6">
          <div className="mb-6">
            <img src={LOGO_WHITE} alt="The Mailbox Brothers LLC" className="h-16 w-auto" />
          </div>
          <p className="font-body text-ice/70 text-lg max-w-md leading-relaxed">
            Fully licensed & insured. Mailbox, fixture & exterior refinishing across {CONTACT.area}. No job too small.
          </p>
        </div>
        <div className="md:col-span-6 flex flex-col gap-4">
          <a href={CONTACT.phoneHref} className="flex items-center gap-3 font-primary uppercase tracking-tight text-ice text-2xl md:text-3xl hover:text-gold transition-colors">
            <Phone size={22} /> {CONTACT.phone}
          </a>
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 font-body text-ice/80 text-lg hover:text-gold transition-colors">
            <Mail size={18} /> {CONTACT.email}
          </a>
          <span className="flex items-center gap-3 font-body text-ice/60 text-lg">
            <MapPin size={18} /> {CONTACT.area}
          </span>
        </div>
      </div>
      <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <p className="font-body text-ice/50 text-sm">© {new Date().getFullYear()} The Mailbox Brothers LLC. All rights reserved.</p>
        <div className="flex items-center gap-6 font-primary uppercase text-sm tracking-widest">
          <Link to="/terms" className="text-ice/60 hover:text-gold transition-colors">Terms</Link>
          <Link to="/privacy" className="text-ice/60 hover:text-gold transition-colors">Privacy</Link>
          <a href="#quote" className="text-gold hover:underline">Book Today →</a>
        </div>
      </div>
    </div>
  </footer>
);
